import { DownloadSimple } from "@phosphor-icons/react";
import { API, getAuthHeaders } from "../context/AuthContext";
import { toast } from "sonner";
import jsPDF from "jspdf";
import "jspdf-autotable";

async function fetchExportData(type, format) {
  const res = await fetch(`${API}/admin/export/${type}?format=${format}`, {
    headers: getAuthHeaders(),
  });
  if (!res.ok) throw new Error("Export failed");
  return res;
}

export default function ExportButtons({ exportType, title }) {
  const handleCSV = async () => {
    try {
      const res = await fetchExportData(exportType, "csv");
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${exportType}_export.csv`;
      a.click();
      URL.revokeObjectURL(url);
      toast.success("CSV exported successfully");
    } catch {
      toast.error("CSV export failed");
    }
  };

  const handlePDF = async () => {
    try {
      const res = await fetchExportData(exportType, "pdf");
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${exportType}_export.pdf`;
      a.click();
      URL.revokeObjectURL(url);
      toast.success("PDF exported successfully");
    } catch {
      toast.error("PDF export failed");
    }
  };

  return (
    <div className="flex items-center gap-1.5">
      <button
        data-testid={`export-csv-${exportType}`}
        onClick={handleCSV}
        className="flex items-center gap-1 px-2 py-1 rounded text-[10px] text-[#A1A1AA] border border-white/10 hover:text-white hover:border-white/20 transition-all"
      >
        <DownloadSimple size={12} />
        CSV
      </button>
      <button
        data-testid={`export-pdf-${exportType}`}
        onClick={handlePDF}
        className="flex items-center gap-1 px-2 py-1 rounded text-[10px] text-[#A1A1AA] border border-white/10 hover:text-white hover:border-white/20 transition-all"
      >
        <DownloadSimple size={12} />
        PDF
      </button>
    </div>
  );
}
